export { default } from './src/SvgMap';
export * from './src/types.d';
